import ServiceSDKModule from "@gtt/service-sdk";

export function NumberToLong(number: number) {
    return (
        ServiceSDKModule as any
    ).tech.gtt.frontapp.servicesdk.interfaces.ServiceSDK.numberToLong(number);
}

export function getLangCode(lang: string) {
    switch (lang) {
        case "en-US":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.English;
        case "zh-CN":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.Chinese;
        case "id-ID":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.Indonesian;
        case "es-ES":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.Spanish;
        case "pt-PT":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.Portuguese;
        case "th-TH":
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.Thai;
        default:
            return ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.base
            .SDKLanguage.English;
    }
}
